import FeaturedFooter from "./FeaturedFooter";

const Footer = () => {
  return <FeaturedFooter />;
};

export default Footer;
